export const ASSET_SEARCH_TASK_ID = "asset_search";

const IN_PROGRESS_STATUSES = ["in_progress", "pending_elayne", "on_it_elayne"];

const SUBMITTED_STATUSES = [...IN_PROGRESS_STATUSES, "completed", "completed_elayne"];

export function isAssetSearchInProgress(status: string | undefined): boolean {
  if (!status) return false;
  return IN_PROGRESS_STATUSES.includes(status);
}

export function isAssetSearchSubmitted(status: string | undefined): boolean {
  if (!status) return false;
  return SUBMITTED_STATUSES.includes(status);
}

export function isAssetSearchComplete(status: string | undefined): boolean {
  if (!status) return false;
  return status === "completed" || status === "completed_elayne";
}
